var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0C7.54688 0 6.5625 0.984375 6.5625 2.1875V32.8125C6.5625 34.0156 7.54688 35 8.75 35H30.625C31.8281 35 32.8125 34.0156 32.8125 32.8125V8.75L24.0625 0H8.75Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 8.75H32.8125L24.0625 0V6.5625C24.0625 7.76562 25.0469 8.75 26.25 8.75Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 15.3125L26.25 8.75H32.8125V15.3125Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4375 28.4375C28.4375 29.0391 27.9453 29.5312 27.3438 29.5312H3.28125C2.67969 29.5312 2.1875 29.0391 2.1875 28.4375V17.5C2.1875 16.8984 2.67969 16.4062 3.28125 16.4062H27.3438C27.9453 16.4062 28.4375 16.8984 28.4375 17.5V28.4375Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9552 20.7231C6.9552 20.4344 7.1827 20.1194 7.54911 20.1194H9.56926C10.7068 20.1194 11.7305 20.8806 11.7305 22.3397C11.7305 23.7222 10.7068 24.4922 9.56926 24.4922H8.10911V25.6472C8.10911 26.0322 7.86411 26.2499 7.54911 26.2499C7.26036 26.2499 6.9552 26.0322 6.9552 25.6472V20.7231ZM8.10911 21.2208V23.3995H9.56926C10.1555 23.3995 10.6193 22.8822 10.6193 22.3397C10.6193 21.7283 10.1555 21.2208 9.56926 21.2208H8.10911Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4433 26.2497C13.1546 26.2497 12.8396 26.0922 12.8396 25.7083V20.7405C12.8396 20.4266 13.1546 20.198 13.4433 20.198H15.446C19.4426 20.198 19.3551 26.2497 15.5248 26.2497H13.4433ZM13.9946 21.2655V25.1833H15.446C17.8074 25.1833 17.9124 21.2655 15.446 21.2655H13.9946Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7726 21.3356V22.7258H23.0028C23.3178 22.7258 23.6328 23.0408 23.6328 23.3459C23.6328 23.6347 23.3178 23.8709 23.0028 23.8709H20.7726V25.7073C20.7726 26.0136 20.5549 26.2487 20.2487 26.2487C19.8637 26.2487 19.6285 26.0136 19.6285 25.7073V20.7395C19.6285 20.4256 19.8648 20.197 20.2487 20.197H23.3189C23.7039 20.197 23.9314 20.4256 23.9314 20.7395C23.9314 21.0195 23.7039 21.3345 23.3189 21.3345H20.7726V21.3356Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3438 29.5312H6.5625V30.625H27.3438C27.9453 30.625 28.4375 30.1328 28.4375 29.5312V28.4375C28.4375 29.0391 27.9453 29.5312 27.3438 29.5312Z",
    fill: "#CAD1D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.11cfc68a.svg";
export { ForwardRef as ReactComponent };